import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription, first } from 'rxjs';
import { EstatusJSON } from '../../../../shared/models/EstatusJSON';
import { MediaMatcher } from '@angular/cdk/layout';
import { MiniMapService } from '../../../../shared/services/MiniMap.service';
import { AlarmDTO } from '../../models/AlarmDTO';
import { AlarmService } from '../../services/Alarm.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';

import { environment } from "src/environments/environment";

@Component({
  selector: 'app-active-alarms-popup',
  templateUrl: './active-alarms-popup.component.html',
  styleUrls: ['./active-alarms-popup.component.css']
})
export class ActiveAlarmsPopupComponent {

  isLoading: boolean = false;
  isLocked: boolean = false;
  canBeLocked: boolean = false;

  alarmData: AlarmDTO;
  idAlarmCategory = -1;

  suscription_getBlockingState: Subscription;
  suscription_getById: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private alarmService: AlarmService,
    private miniMapService: MiniMapService,
    private citronellaActionsService: CitronellaActionsService,
    public dialogRef: MatDialogRef<ActiveAlarmsPopupComponent>,
    private toasterService: NotificationsToastService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.GetAlarmById();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    if(this.suscription_getBlockingState)
      this.suscription_getBlockingState.unsubscribe();
    if(this.suscription_getById)
      this.suscription_getById.unsubscribe();
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  obtainBlockingState(){
    // this.isLoading = true;
    this.suscription_getBlockingState = this.citronellaActionsService.getBlokingState(this.alarmData.identifier)
    .pipe(first())
    .subscribe({
      next: (alarmData: EstatusJSON) => {
        if(alarmData.isSuccess){
          this.isLocked = alarmData.result.locked;
        }else{
          this.canBeLocked = false;
          Sentry.captureMessage('ActiveAlarmsPopup.obtainBlockingState: isSuccess false', { level: 'warning', extra: { response: alarmData } });
        }
        // this.isLoading = false;
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener estado de bloqueo', error);
        // this.isLoading = false;
        this.canBeLocked = false;
      }
    });
  }

  GetAlarmById(){
    this.isLoading = true;
    if(!environment.production) console.log("GetAlarmById", this.data.id);
    
    this.suscription_getById = this.alarmService.getById(this.data.id).subscribe({
      next: (alarmData) => {
        if(alarmData.isSuccess){
          this.alarmData = alarmData.result;
          this.idAlarmCategory = alarmData.result.idAlarmCategory;
          
          this.alarmData.notificationList = this.alarmData.notificationList.filter(
            (notification, index, self) =>
              index === self.findIndex((n) => n.notificationType === notification.notificationType)
          );
          this.isLoading = false;
          this.obtainBlockingState();
          this.createMap();
        }else{
          this.isLoading = false;
          this.toasterService.showError("Error", "No se pudo obtener la alarma, contacte con el administrador");
          Sentry.captureMessage('ActiveAlarmsPopup.GetAlarmById: isSuccess false', { level: 'warning', extra: { response: alarmData } });
          this.closeDialog();
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        this.isLoading = false;
        console.error('Error al obtener alarma', error);
        this.toasterService.showError("Error", "No se pudo obtener la alarma, contacte con el administrador");
        this.closeDialog();
      }
    });
  }

  createMap(){
    this.waitForElement('mini-map').then(() => {
      this.miniMapService.CreateMap(this.alarmData.detonatorGeometry, this.alarmData.locationGeometry);
    }).catch(() => {
      if(!environment.production) console.log("miniMap no encontrado, repito");
      setTimeout(() => {
        this.createMap();  // Reintenta la creación
      }, 1000);
    });
  }

  waitForElement(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        const element = document.getElementById(id);
        if (element) {
          clearInterval(interval);
          resolve();
        }
      }, 1000);
    });
  }

  ResizeMap(){
    setTimeout(() => {
      this.miniMapService.ResizeMap();
    }, 200);
  }
}
